<template>
	<div class="role-authorization wrapper">
		
		<div class="content-page">
			<div class="content">
				<el-row :gutter="10">
					<el-col :span="4">
						<div class="role-box">
							<div class="box-title">用户角色授权</div>
							<ul class="box-list">
								<li :class="{ active: curRoleIndex === index }" v-for="(item, index) in roleList" :key="index" @click="changeRoleIndex(index)">{{ item }}</li>
							</ul>
						</div>
					</el-col>
					<el-col :span="20">
						<TopicManager v-if="curRoleIndex === 0"></TopicManager>
						<FirstExaminer v-if="curRoleIndex === 1"></FirstExaminer>
						<ReviewExpert v-if="curRoleIndex === 2"></ReviewExpert>
						<Supervisor v-if="curRoleIndex === 3"></Supervisor>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import TopicManager from './components/TopicManager.vue';
import FirstExaminer from './components/FirstExaminer';
import ReviewExpert from './components/ReviewExpert.vue';
import Supervisor from './components/Supervisor.vue';
export default {
	components: {
		TopicManager,
		FirstExaminer,
		ReviewExpert,
		Supervisor
	},
	data() {
		return {
			// roleList: ['课题管理员', '初审员', '评审专家', '论文评审管理员', '成果评审管理员', '评先进个人管理员', '评先进集体管理员', '系统管理员'],
			roleList: ['区级管理员', '学校管理员', '评审专家','主管领导'],
			curRoleIndex: 0
		};
	},
	methods: {
		changeRoleIndex(index) {
			this.curRoleIndex = index;
		}
	}
};
</script>

<style scoped lang="scss">

.role-box {
	// width: 200px;
	background-color: #fff;
	box-shadow: 0px 0px 8px #eeeeee;
	.box-title {
		line-height: 50px;
		font-size: 14px;
		text-align: center;
		border-bottom: 2px solid #e3eaef;
	}
	.box-list {
		list-style: none;
		padding: 0;
		color: #000;
		li {
			padding-left: 20%;
			cursor: pointer;
			line-height: 40px;
		}
		li.active,
		li:hover {
			line-height: 40px;
			background-color: #99aee2;
		}
	}
}

</style>
